import { Badge } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';

import { Container } from '../layout/container';
import { ReportBars } from '../marketing/report-bars';

/*
 * Deliberately asymmetric (one wide cell, three narrower ones with
 * different internal compositions: chip cluster, bar chart, plain copy,
 * badge) rather than four identical icon+heading+text cards.
 */
export function FeatureBentoSection() {
  const { t } = useTranslation('marketing');

  const reportRows = [
    { label: t('home.bento.reportRows.clientRedesign'), hours: '12h 30m', width: '92%', highlight: true },
    { label: t('home.bento.reportRows.internalTooling'), hours: '8h 05m', width: '64%' },
    { label: t('home.bento.reportRows.supportRotation'), hours: '5h 45m', width: '46%' },
    { label: t('home.bento.reportRows.admin'), hours: '2h 15m', width: '18%' },
  ];

  return (
    <section className="border-b border-border py-16 md:py-24">
      <Container>
        <div className="grid gap-4 md:grid-cols-2">
          <div className="rounded-md border border-border p-6 md:col-span-2 md:p-8">
            <h3 className="text-title text-ink">{t('home.bento.projectsHeading')}</h3>
            <p className="mt-2 max-w-[65ch] text-body text-muted">{t('home.bento.projectsBody')}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <Badge variant="neutral">{t('home.bento.badges.client')}</Badge>
              <Badge variant="neutral">{t('home.bento.badges.redesign')}</Badge>
              <Badge variant="gold">{t('home.bento.badges.billable')}</Badge>
              <Badge variant="teal">{t('home.bento.badges.deepWork')}</Badge>
              <Badge variant="neutral">{t('home.bento.badges.followUp')}</Badge>
            </div>
          </div>

          <div className="rounded-md border border-border p-6">
            <h3 className="text-title text-ink">{t('home.bento.reportsHeading')}</h3>
            <p className="mt-2 text-body text-muted">{t('home.bento.reportsBody')}</p>
            <div className="mt-5">
              <ReportBars rows={reportRows} />
            </div>
          </div>

          <div className="rounded-md border border-border p-6">
            <h3 className="text-title text-ink">{t('home.bento.remindersHeading')}</h3>
            <p className="mt-2 text-body text-muted">{t('home.bento.remindersBody')}</p>
            <div className="mt-5 flex items-start gap-3 rounded-md border border-border bg-surface p-3">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-gold" aria-hidden />
              <p className="text-body text-ink">{t('home.bento.remindersSample')}</p>
            </div>
            <p className="mt-4 text-body text-muted">{t('home.bento.remindersShareBody')}</p>
            <Badge variant="teal" className="mt-3">
              {t('home.bento.guestBadge')}
            </Badge>
          </div>
        </div>
      </Container>
    </section>
  );
}
